<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card class="pl-5 pr-5 pt-5">
      <v-card-text class="body-1" v-html="text"></v-card-text>
      <v-card-actions>
        <v-container class="text-right  pa-0 ma-0">
          <v-btn text color="error" large @click="no" @keydown.esc="no">No</v-btn>
          <v-btn text color="success" large @click="yes" @keydown.enter="yes">Yes</v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from "../EventBus";

export default {
  name: "AConfirmDialog",
  data() {
    return {
      title: "Hello",
      text: "Test",
      show: false,
      onYes: undefined,
      onNo: undefined
    };
  },
  mounted() {
    EventBus.$on("ConfirmDialogOpen", d => {
      this.open(d);
    });
  },  
  methods: {
    open(d) {
      this.title = d ? d.title : "";
      this.text = d ? d.text : "";
      this.onYes = d ? d.onYes : undefined;
      this.onNo = d ? d.onNo : undefined;
      this.show = true;
    },
    yes() {
      this.show = false;
      this.$emit("yes");
      if (this.onYes) this.onYes();
    },
    no() {
      this.show = false;
      this.$emit("no");
      if (this.onNo) this.onNo();
    }
  }
};
</script>